import React from 'react';
import './TransactionItem.css';

const TransactionItem = ({ transaction, currentUser, users }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'numeric',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const getUserById = (id) => {
    return users?.find(user => user.id === id);
  };

  const otherUser = transaction.sender_id === currentUser?.id 
    ? getUserById(transaction.receiver_id)
    : getUserById(transaction.sender_id);
  
  const isOutgoing = transaction.sender_id === currentUser?.id;
  const isPayment = transaction.type === 'payment';
  const isCharge = transaction.type === 'charge';
  const isRequest = transaction.type === 'request';
  
  let actionText = '';
  let amountClass = '';
  
  if (isPayment) {
    actionText = isOutgoing ? 'You paid' : 'paid you';
    amountClass = isOutgoing ? 'amount-outgoing' : 'amount-incoming';
  } else if (isCharge) {
    actionText = isOutgoing ? 'You charged' : 'charged you';
    amountClass = isOutgoing ? 'amount-incoming' : 'amount-outgoing';
  } else if (isRequest) {
    actionText = isOutgoing ? 'You requested from' : 'requested from you';
    amountClass = 'amount-pending';
  }

  return (
    <div className="transaction-item">
      <div className="transaction-main">
        <img
          src={otherUser?.profile_picture || 'https://i.pravatar.cc/40?img=1'}
          alt={otherUser?.name || 'User'}
          className="transaction-avatar"
        />
        
        <div className="transaction-details">
          <div className="transaction-text">
            <span className="action-text">{actionText} </span>
            <span className="user-name">{otherUser?.name || 'Unknown User'}</span>
          </div>
          
          <div className="transaction-note">{transaction.note}</div>
          <div className="transaction-date">{formatDate(transaction.created_at)}</div>
        </div>
        
        <div className={`transaction-amount ${amountClass}`}>
          {isOutgoing && (isPayment || isCharge) ? '-' : '+'}
          {transaction.status === 'pending' ? '' : ''}
          {formatCurrency(transaction.amount)}
        </div>
      </div>
    </div>
  );
};

export default TransactionItem;
